const initMobileHeader = () => {
    $('header .mobile-menu-btn').click(function () {
        $(this).toggleClass('menu-opened')
        $('.mobile-nav').toggleClass('open');
    });
};

export default initMobileHeader;
